import { render } from "./HeroiconsSolidLogin.vue?vue&type=template&id=611acd21"
const script = {}

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLogin.vue"]])

export default __exports__